<template>
  <div>
      <v-app-bar class="white">
         <router-link to="/" tag="card">
       <img class="ml-5" :src="require('../assets/operationwise_logo.png')" height="40"/>
       </router-link>
       <v-spacer />
         <v-avatar color="black">
             <h3 class="orange--text">JD</h3>
         </v-avatar>
      </v-app-bar>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>